var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"entry-wrapper",on:{"click":function($event){return _vm.$emit('update', this)}}},[_c('div',{staticClass:"entry__headline icon-angle-right-after"},[_c('h5',[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }